
import React from 'react';
import { useImmer } from 'use-immer';
import { VariablesT } from '../../../../types/Company';
import { JobT, RevenueLineItemT } from '../../../../types/Job';
import { getCurrentUserId } from '../../../../utils/currentUser';
import { LineItemPayment } from './LineItemPayment';
import { Button, Typography, Box } from '@mui/material';
import { copyObject, randomId } from '../../../../utils';
import * as _ from 'lodash'
import { Image } from 'react-bootstrap'
import images from '../../../../constants/images';
import PayByCard from '../../../../components/FormPaymentJob/PayByCard/PayByCard';
import { LineItemTransactionT } from '../../../../types/TransactionT';


export type IFormPaymentsProps = {
    job: JobT
    companyVariables: VariablesT
    lineItems: Array<RevenueLineItemT>
    titleButton: string
    refresh(): Promise<void>
}

const PayJob: React.FC<IFormPaymentsProps> = (props) => {
    const [showFormPayment, setShowFormPayment] = React.useState(false);
    const [showFormTip, setShowFormTip] = React.useState(false);
    const [showFormAddCard, setShowFormAddCard] = React.useState(false);
    const currentUserId = getCurrentUserId()

    const [lineItemTip, setLineItemTip] = React.useState<LineItemTransactionT | null>(null);
    const [state, setState] = useImmer({
        lineItems: [],
        extendsLineItems: [],
        lineItemTip: null,
    });


    React.useEffect(() => {
        if (props.job.jobStatus == "inquiring") {
            const findItem = state.lineItems.find((x) => x.item == "serviceFee")
            if (!findItem) {
                const serviceFee = props.companyVariables.depositLocal.value
                const lineItemServiceFee = generateLineItem(serviceFee, 'serviceFee')
                setState((draft) => {
                    draft.lineItems.push(lineItemServiceFee)
                })
            }

        } else {
            setState((draft) => {
                draft.lineItems = props.lineItems
            })
        }

    }, [props.lineItems]);



    const allLineItems = React.useMemo(() => {
        let items = copyObject(state.lineItems)
        if (state.lineItemTip) {
            items.push(state.lineItemTip)
        }
        return items
    }, [state.lineItems, state.lineItemTip]);



    const renderListItems = () => {

        // @ts-ignore

        // const items = [...state.lineItems, ...state.extendsLineItems]
        return allLineItems.map((item, index) => {
            if (item.total > 0 && item.rate > 0 && item.units > 0) {
                return (
                    <LineItemPayment
                        key={index}
                        job={props.job}
                        index={index}
                        companyVariables={props.companyVariables}
                        item={item}
                    />
                )
            } else {
                return null
            }
        })

    }

    const generateLineItem = (amount, item): RevenueLineItemT => {

        return {
            total: amount,
            id: randomId(12),
            item: item,
            rate: amount,
            units: 1,
            date: new Date().toString()
        }
    }

    const prepareLineItemsPayments = React.useCallback(() => {
        // @ts-ignore
        // const items = [...state.lineItems, ...state.extendsLineItems]
        let lineItems = []
        state.lineItems.map((item, index) => {
            const units = item.units && item.units >= 1 ? item.units : 1
            if (item.total > 0 && item.rate > 0 && item.units > 0) {
                lineItems.push({
                    amount: item.total,
                    productItemId: !_.isNil(item.id) ? item.id : randomId(12),
                    productItem: item.item,
                    productRate: item.rate,
                    productUnits: item.units
                })
            }

        })
        return lineItems
    }, [state]);



    // console.log("lineItems->lineItems", state.lineItems);
    // console.log("lineItems", prepareLineItemsPayments());
    return (
        <div>
            {/*
            <FormSaveCard
                publishableKey={config.stripePublishableKey}
                completeSaveCard={async (paymentMethodId): Promise<string> => {
                    let params = {
                        paymentMethodId: paymentMethodId,
                    }
                    return await AxiosInstance.post(`${config.url.cards}/stripe`, params).then((res) => {
                        if (res && res.data) {
                            return res.data
                        }
                    })

                }} /> */}


            {!showFormPayment && <>
                <Box display="flex" className="flex-row" >
                    <Image style={{ height: 50, width: 50 }} src={props.job.companyInfo.logo != "" ? props.job.companyInfo.logo : images.DEFAULT} />
                    <Box className="d-flex justify-content-center align-items-center p-2">
                        <Typography variant="h6">{props.job.companyInfo.name}</Typography>
                    </Box>
                </Box>
                {renderListItems()}
            </>}

            <PayByCard
                productId={props.job.id}
                productType="jobs"

                // amount={amount}
                userId={currentUserId}

                toggleView={(value) => {
                    setShowFormPayment(value)
                }}
                displayFormTip={props.job.jobStatus != "inquiring" ? true : false}

                addLineItemTip={(item) => {
                    const lineItem = {
                        total: item.amount,
                        id: item.productItemId,
                        item: item.productItem,
                        rate: item.productRate,
                        units: item.productUnits,
                        date: new Date().toString()
                    }
                    setState((draft) => {
                        draft.lineItemTip = lineItem
                    })
                }}
                removeLineItemTip={() => {
                    setState((draft) => {
                        draft.lineItemTip = null
                    })
                }}
                paymentItems={prepareLineItemsPayments()}

                titleButton={props.titleButton ? props.titleButton : "Pay Now"}
                customButtonProps={{
                    fullWidth: true
                }}
                onCompleteProcessing={(transaction) => {

                    setState((draft) => {
                        draft.lineItems = []
                        draft.extendsLineItems = []
                        draft.lineItemTip = null
                    })

                    setShowFormPayment(false)
                    setShowFormTip(false)
                    setShowFormAddCard(false)
                    if (props.refresh) {
                        props.refresh()
                    }
                }}

            />

            {/* {showFormPayment && <FormPaymentCheckout
                productId={props.job.id}
                productType="jobs"
                // amount={amount}
                userId={currentUserId}

                lineItems={prepareLineItemsPayments()}
                onCompleteProcessing={(transaction) => {

                    setState((draft) => {
                        draft.lineItems = []
                        draft.extendsLineItems = []
                    })
                    setShowFormPayment(false)
                    setShowFormTip(false)
                    setShowFormAddCard(false)
                    if (props.refresh) {
                        props.refresh()
                    }



                    // saveChange(props.crewSize, transaction)
                    // props.hide()
                }}
                onShowFormAddCard={() => {
                    setShowFormAddCard(true)
                }}
                showAddCard={showFormAddCard}
            />} */}



            {/* <Button fullWidth variant="contained"
                color={!showFormPayment ? "success" : "error"}
                size={"large"} className="mt-2" onClick={(e) => {
                    e.preventDefault()
                    if (showFormAddCard) {
                        setShowFormAddCard(false)
                        return ""
                    }
                    if (showFormPayment) {
                        setShowFormPayment(false)
                    } else {
                        if (!showFormTip && props.job.jobStatus != "inquiring") {
                            setShowFormTip(true)
                        } else {
                            setShowFormTip(false)
                            setShowFormPayment(true)
                        }
                    }
                }} ><Typography fontWeight="bold" color="#fff">{showFormPayment ? "Cancel" : showFormTip ? "Pay Now" : props.titleButton}</Typography>
            </Button> */}
        </div>
    );
}
export default PayJob
export { PayJob }
